import { BaseFirestoreRepository } from 'core/base-firestore.repository';
import { FIRESTORE_COLLECTIONS } from '@core/constants/collections.constants';
import { query, collection, limit, where, getDocs } from 'firebase/firestore';
import { UserProfile } from './user-profile.model';
import jsonHelper from '@core/helpers/jsonHelper';

export default class UserProfileRepository extends BaseFirestoreRepository<UserProfile> {
  constructor() {
    super(FIRESTORE_COLLECTIONS.USERS);
  }

  addUid = (entity: UserProfile, uid?: string) => {
    if (!entity.firebaseUids) {
      entity.firebaseUids = [];
    }
    if (!uid) {
      return;
    }
    if (entity.firebaseUids.includes(uid)) {
      return;
    }
    entity.firebaseUids.push(uid);
  };

  async getByEmail(email: string): Promise<UserProfile> {
    if (!email) return new UserProfile();
    const q = query(
      collection(this.db, this.collectionName),
      where('email', '==', email),
      limit(1),
    );
    const snapshot = await getDocs(q);
    if (snapshot.empty) {
      const user = new UserProfile();
      user.name = email.split('@')[0];
      user.email = email;
      return user;
    }
    return snapshot.docs.map(doc =>
      jsonHelper.castTo<UserProfile>({ ...doc.data(), id: doc.id }),
    )[0];
  }
}
